<app-leveltwo [pageName]="'New Homeowners'">
  <div class="General">
      <h3>{{'NewHomeowners.PageTitle'|translate}}</h3>
      <p>{{'NewHomeowners.description'|translate}}</p>
      <h4>{{'NewHomeowners.homeex'|translate}}</h4>
      <p>{{'NewHomeowners.homeexdesc'|translate}}</p>
      <button *ngIf="!toggle" type="button" class="btn btn-primary" [routerLink]="['../homeowner-exemption/']">{{'NewHomeowners.homeexbutton'|translate}}</button>
      <button *ngIf="toggle" type="button" class="btn btn-primary" [routerLink]="['../apply-for-hox']">{{'NewHomeowners.homeexbutton'|translate}}</button>
      <!-- <a href="https://assessor.lacounty.gov/exemptions/homeowner-exemption"><button *ngIf="!toggle" type="button" class="btn btn-primary" >{{'NewHomeowners.homeexbutton'|translate}}</button></a> -->
      <!-- <div *ngIf="router.isActive('/real-estate-toolkit/new-homeowners') else elseBlock">
        <button type="button" class="btn btn-primary" [routerLink]="['../apply-for-hox/']">{{'NewHomeowners.homeexbutton'|translate}}</button>
      </div>
      <ng-template #elseBlock>Content to render when condition is false.</ng-template> -->
      <br><br>
      <h4>{{'NewHomeowners.annualproptax'|translate}}</h4>
      <p>{{'NewHomeowners.annualproptaxdesc'|translate}}</p>
      <p><b [innerHTML]="'NewHomeowners.annualproptaxdescbold'|translate"></b></p>
      <p [innerHTML]="'NewHomeowners.annualproptaxdesc2'|translate"></p>
      <p><b>{{'NewHomeowners.annualproptaxdescbold2'|translate}}</b></p>
      <h4>{{'NewHomeowners.supproptax'|translate}}</h4>
      <p>{{'NewHomeowners.supproptaxdesc'|translate}}</p>
      <p>{{'NewHomeowners.supproptaxdesc2notaxestimator'|translate}}</p>
      <!-- <button type="button" class="btn btn-primary" [routerLink]="['../supplemental-tax-estimator/']">{{'NewHomeowners.supproptaxbutton'|translate}}</button> -->
      <!-- <br><br> -->
      <h4>{{'NewHomeowners.transferexc'|translate}}</h4>
      <p>{{'NewHomeowners.transferexcdesc'|translate}}</p>
      <button type="button" class="btn btn-primary" [routerLink]="['../proposition-19/']">{{'NewHomeowners.prop19button'|translate}}</button>
      <br><br>
      <p [innerHTML]="'NewHomeowners.assistancev2'|translate"></p>




  </div>
</app-leveltwo>
